import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const ActionButtons = ({ 
  onExportExcel, 
  onExportPDF, 
  additionalActions,
  showExport = true,
  uniqueId = "default"
}) => {
  const [exportOpen, setExportOpen] = useState(false);
  const exportRef = useRef(null);

  useEffect(() => {
    const handleDocClick = (e) => {
      if (exportRef.current && !exportRef.current.contains(e.target)) {
        setExportOpen(false);
      }
    };
    const handleKey = (e) => { if (e.key === 'Escape') setExportOpen(false); };
    document.addEventListener('click', handleDocClick);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('click', handleDocClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, []);

  const handleClick = (callback) => {
    setExportOpen(false);
    callback?.();
  };

  const hasExportCapability = onExportExcel || onExportPDF;

  return (
    <div className="d-flex gap-2">
      {showExport && hasExportCapability && (
        <div className="dropdown" ref={exportRef}>
          <button
            type="button"
            id={`export-dropdown-button-${uniqueId}`}
            className="btn btn-outline-primary dropdown-toggle"
            aria-label="Export options"
            aria-expanded={exportOpen}
            aria-haspopup="true"
            onClick={(e) => { e.stopPropagation(); setExportOpen(v => !v); }}
          >
            Export
          </button>
          <div
            className={`dropdown-menu dropdown-menu-end${exportOpen ? ' show' : ''}`}
            role="menu"
            aria-labelledby={`export-dropdown-button-${uniqueId}`}
            style={{ right: 0, left: 'auto', zIndex: 1050 }}
          >
            {onExportExcel && (
              <button className="dropdown-item" onClick={() => handleClick(onExportExcel)}>
                Export to Excel
              </button>
            )}
            {onExportPDF && (
              <button className="dropdown-item" onClick={() => handleClick(onExportPDF)}>
                Export to PDF
              </button>
            )}
          </div>
        </div>
      )}
      {additionalActions}
    </div>
  );
};

ActionButtons.propTypes = {
  onExportExcel: PropTypes.func,
  onExportPDF: PropTypes.func,
  additionalActions: PropTypes.node,
  showExport: PropTypes.bool,
  uniqueId: PropTypes.string
};

export default ActionButtons;
